module.exports = "/assets/ccc7b81040966874e8b04b3f6d5f1633.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5J.png
// module id = 1061
// module chunks = 0